var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticStyle:{"width":"100%","height":"100%"},attrs:{"object-fit":"fill","src":"https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700711015035.mp4","autoplay":"","loop":""},on:{"click":_vm.goIndex}})])
}
var staticRenderFns = []

export { render, staticRenderFns }